import AutocompleInput from './AutocompleteInput'

export default AutocompleInput
